import {
  GIF_FILE_TYPE,
  JPEG_FILE_TYPE,
  MSOFFICE_FILE_TYPE,
  MSWORD_FILE_TYPE,
  PDF_FILE_TYPE,
  PNG_FILE_TYPE,
} from 'fe-design-base/organisms/FileUpload/constants';

export const DEFAULT_ACCEPTED_FILE_TYPES = {
  ...JPEG_FILE_TYPE,
  ...PNG_FILE_TYPE,
  ...PDF_FILE_TYPE,
  ...MSWORD_FILE_TYPE,
  ...MSOFFICE_FILE_TYPE,
};

export const CERTIFICATE_ROW_TYPES = {
  ...PNG_FILE_TYPE,
  ...PDF_FILE_TYPE,
  ...JPEG_FILE_TYPE,
  ...GIF_FILE_TYPE,
};
